import { render, staticRenderFns } from "./ShippingListManual.vue?vue&type=template&id=1a074116"
import script from "./ShippingListManual.vue?vue&type=script&lang=js"
export * from "./ShippingListManual.vue?vue&type=script&lang=js"
import style0 from "./ShippingListManual.vue?vue&type=style&index=0&id=1a074116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports